module.exports = __webpack_public_path__ + "static/media/deine-buga__image--close.8c051c0c.svg";